module.exports = __webpack_public_path__ + "images/interview-Booz_Allen_Hamilton-2.svg";